import moment from 'moment';
import store from '@/store/store';
import formatDateIso from '@/services/general/formatIsoDate';
import { importIdeliaCommandeAsync } from '@/api/import';
import validationDataImportCommande from '@/services/importClient/commande/validationDataImportCommande';

export function makeCommandeGenerated(file) {
  const data = file[0].map((ligne) => {
    const { numLigne, ...restligne } = ligne;
    return {
      ...restligne,
      dateCommande: moment(restligne.dateCommande).isValid()
        ? formatDateIso(restligne.dateCommande) : '',
    };
  });
  return data;
}

export async function makeCommandeImport(data, modetest) {
  const agencesActive = store.getters['societe/agenceActive'];
  const response = (await importIdeliaCommandeAsync({
    lignes: data,
    modeTest: modetest,
    agenceId: agencesActive[0].agenceId,
    societeId: store.getters['societe/societeActiveId'],
  })).data.result;
  if (response?.some((r) => r.messages.length > 0)) {
    validationDataImportCommande(response);
    throw response;
  }
}
